/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

//import translation function for language translation
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

// modules for process
import ProcessModuleOptions from "data/Prod/ProcessModuleOptions.json";

//import context
import { GlobalProvider } from "context/GlobalContext";
import { reactSelectStyle } from "Config/Config";
// import { reorder } from "helper/Common/CommonHelper";

const SaveActivityProcessPopup = ({
  afterPopupClose,
  selectedProcessId,
  setSelectProcessId,
  isTemplate,
  moduleSlug,
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
  requestBoardUpdate,
  setRequestBoardUpdate = () => {},
}) => {
  const token = localStorage.getItem("token");
  const { t } = useTranslation(); //for translation
  const [tagList, setTagList] = useState([]);

  const [title, settitle] = useState("");
  const [slug, setslug] = useState("");
  const [tagValue, settagValue] = useState([]);
  const [selectedTags, setselectedTags] = useState([]);

  const [followersOptions, setFollowersOptions] = useState([]);
  const [followersValue, setFollowersValue] = useState(null);
  const [selectedFollowers, setselectedFollowers] = useState([]);
  const [followersInput, setFollowersInput] = useState("");

  const [moduleValue, setModuleValue] = useState(null);
  const [selectedModule, setSelectedModule] = useState(moduleSlug);

  /* hooks for validation */
  const titleRef = useRef(null);
  const [errors, setErrors] = useState({});

  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");

  // validate =========================
  const validateForm = () => {
    const newErrors = {};

    if (!title.trim()) {
      newErrors.title = t(
        "Process name cannot be empty. Please provide a name."
      );
    }
    if (!slug.trim()) {
      newErrors.slug = t(
        "Process slug cannot be empty. Please provide a unique slug."
      );
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      if (newErrors.title && titleRef.current) {
        setTimeout(() => {
          titleRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
          titleRef.current.setAttribute("tabindex", "-1");
          titleRef.current.focus();
        }, 100);
      }
    }

    return Object.keys(newErrors).length === 0;
  };

  // Reorder function for drag-and-drop
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  // Handle drag-and-drop end
  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedTags = reorder(
      tagValue,
      result.source.index,
      result.destination.index
    );
    settagValue(reorderedTags);
    setselectedTags(
      reorderedTags.map((item) => ({
        tagid: item.value,
        componentorderid: item?.componentorderid ?? null,
      }))
    );
  };

  //function for get all tags
  const getAllTags = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_TAGS +
        `?modulename=${moduleSlug}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setTagList(response.data);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //function for get followers list
  const getFollowersList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `?userstringinput=${followersInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        if (response.data.length > 0) {
          setFollowersOptions(response.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  //select followers
  const followersSelectionHandler = (val) => {
    setFollowersValue(val);
    setselectedFollowers(val.map((item) => item.value));
  };

  //function for get followers input
  const followersInputHandler = (val) => {
    setFollowersInput(val);
  };

  //select module
  const moduleSelectionHandler = (val) => {
    if (val) {
      setModuleValue(val);
      setSelectedModule(val.value);
    } else {
      setModuleValue(null);
      setSelectedModule("");
    }
  };

  //select tags
  const tagSelectionHandler = (val) => {
    if (val) {
      settagValue(val);
      setselectedTags(
        val.map((item) => ({
          tagid: item.value,
          componentorderid: item?.componentorderid ?? null,
        }))
      );
    } else {
      settagValue([]);
      setselectedTags([]);
    }
  };

  //get process details
  const getProcessDetails = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_PROCESS_DETAILS +
        `/${selectedProcessId}`;

      const response = await getData(requestURL);

      if (response.status && response.data) {
        settitle(response.data.title);

        setslug(response.data.slug);

        if (response.data.tagvalues.length > 0) {
          tagSelectionHandler(response.data.tagvalues);
        }

        if (response.data.followersArr) {
          followersSelectionHandler(response.data.followersArr);
        }

        for (let moduleData of ProcessModuleOptions) {
          if (moduleData.value === response.data.moduleslug) {
            moduleSelectionHandler(moduleData);
          }
        }
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //save process
  const saveProcessHandler = async () => {
    if (validateForm()) {
      seterrorMessage("");

      try {
        setIsSaving(true);

        let processData = {
          title,
          slug: slug.toUpperCase(),
          moduleslug: selectedModule,
          istemplate: isTemplate,
          tags: selectedTags,
          followers: selectedFollowers,
        };

        let requestURL = url.API_BASE_URL;

        let response = {};

        if (selectedProcessId) {
          requestURL +=
            url.API_UPDATE_PROCESS + `/${selectedProcessId}`;

          response = await putData(requestURL, processData);
        } else {
          requestURL += url.API_ADD_NEW_PROCESS;

          response = await postData(requestURL, processData);
        }

        setIsSaving(false);

        if (response.status) {
          setMessageType("success");
          resetHandler();
          bootstrap.Offcanvas.getInstance(
            document.querySelector("#activityProcessOffCanvas")
          ).hide();
          afterPopupClose();
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      seterrorMessage(t("Please fill up required fields"));
      setMessageType("error");
      setAlertMessage("Please fill up required fields");
    }

    setShowAlert(true);
  };

  const resetHandler = () => {
    setRequestBoardUpdate(false);
    settitle("");
    setslug("");
    settagValue([]);
    setselectedTags([]);
    setErrors({});
    seterrorMessage("");

    setModuleValue(null);
    setSelectedModule("");
    setFollowersValue(null);
  };

  useEffect(() => {
    if (selectedProcessId && requestBoardUpdate) {
      getProcessDetails();
    }
  }, [selectedProcessId, requestBoardUpdate]);

  useEffect(() => {
    getAllTags();
  }, []);

  useEffect(() => {
    if (followersInput.length > 0) {
      getFollowersList();
    }
  }, [followersInput]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="activityProcessOffCanvas"
      aria-labelledby="activityProcessOffCanvas"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              settings_suggest
            </span>{" "}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="activityProcessOffCanvas"
            >
              {t("Save Activity Process")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {selectedProcessId
                ? t("Manage existing activity process details")
                : t("Define a new activity process")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              {/* title */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="title"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Process Name")} <span className="text-danger">*</span>
                </label>
                <input
                  ref={titleRef}
                  type="text"
                  className={`form-control fs-sm shadow-none ${
                    errors.title ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("Enter here")}
                  value={title}
                  onChange={(e) => {
                    settitle(e.target.value);
                    if (errors.title) {
                      setErrors((prev) => ({ ...prev, title: "" }));
                    }

                    const newSlug = e.target.value
                      .trim()
                      .toLowerCase()
                      .replace(/\s+/g, "-");

                    setslug(newSlug);
                  }}
                  aria-describedby="titleFeedback"
                />
                {errors.title && (
                  <div id="titleFeedback" className="invalid-feedback">
                    {errors.title}
                  </div>
                )}
              </div>

              {/* slug */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="slugID"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Slug")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="slug"
                  className={`form-control fs-sm shadow-none ${
                    errors.slug ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("Enter here")}
                  value={slug}
                  onChange={(e) => {
                    setslug(e.target.value);
                    if (errors.slug) {
                      setErrors((prev) => ({ ...prev, slug: "" }));
                    }
                  }}
                  aria-describedby="slugFeedback"
                />
                {errors.slug && (
                  <div id="slugFeedback" className="invalid-feedback">
                    {errors.slug}
                  </div>
                )}
              </div>

              {/* tags */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="labels"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Labels")}
                </label>
                <Select
                  isMulti
                  placeholder={t("Select tags")}
                  options={tagList}
                  value={tagValue}
                  onChange={(val) => {
                    tagSelectionHandler(val);
                  }}
                  styles={reactSelectStyle("3px", "6px", true, false)}
                />
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId="tags">
                    {(provided) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={{ marginTop: "10px" }}
                      >
                        {tagValue.map((tag, index) => (
                          <Draggable
                            key={tag.value}
                            draggableId={tag.value.toString()}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  padding: "8px",
                                  marginBottom: "4px",
                                  backgroundColor: "#f1f1f1",
                                  borderRadius: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  ...provided.draggableProps.style,
                                }}
                              >
                                <span>{tag.label}</span>
                                <span
                                  style={{
                                    cursor: "grab",
                                    fontSize: "16px",
                                    color: "#888",
                                  }}
                                >
                                  ☰
                                </span>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>

              {/* <!-- ========== Start followers Section ========== --> */}

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="followers"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Followers")}
                </label>
                <Select
                  isMulti
                  placeholder={t("Type user name or email")}
                  options={followersOptions}
                  value={followersValue}
                  onChange={(val) => followersSelectionHandler(val)}
                  onInputChange={(val) => {
                    followersInputHandler(val);
                  }}
                  styles={reactSelectStyle("3px", "6px", true, false)}
                />
              </div>

              {/* <!-- ========== End followers Section ========== --> */}

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="selectModule"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Select Module")}
                </label>
                <Select
                  isClearable
                  placeholder={t("Select Module")}
                  options={ProcessModuleOptions}
                  value={moduleValue}
                  onChange={(val) => moduleSelectionHandler(val)}
                  styles={reactSelectStyle("3px", "6px", true, false)}
                />
              </div>
            </div>

            <div className="action d-flex justify-content-end pt-3 border-top mt-auto align-items-center gap-3 mb-3">
              {errorMessage === "" ? null : (
                <div className="error-message">
                  <p className="d-flex align-items-center gap-1 text-danger mb-0">
                    <span className="material-symbols-outlined">warning</span>
                    <span>{errorMessage}!</span>
                  </p>
                </div>
              )}
              <button
                onClick={saveProcessHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving Process...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Process")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveActivityProcessPopup;
